export default {
  PASSWORD:
    /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[a-zA-Z!@#$%^&*()-_=+/|*"])[a-zA-Z0-9!@#$%^&*()-_=+/|*"]{12,}$/,
  ONLY_NUMBERS: /^[0-9]*$/,
  ONLY_LETTERS: /^[A-Za-z]*$/,
  COUNTRY_CODES: /d\+1/,
  MAC_ADDRESS:
    /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})|([0-9a-fA-F]{4}\\.[0-9a-fA-F]{4}\\.[0-9a-fA-F]{4})$/,
};
